// API 設定（Claude APIキー / モデル / max_tokens、音声用の Gemini APIキー / モデル）のポップオーバー（UI.md §3.1）。
//
// 役割: ブラウザ直叩きに必要な Claude APIキー等と、音声機能（Gemini Live）のキーを入力し、
//       localStorage へ保存する UI。キーはバンドルに埋め込まず利用者が入力する方針
//       （共有端末では削除を促す）。
// 関係: 値と保存処理は App が管理。ヘッダー右側に差し込む。
//
// 流用元: reference/e-Stat-Web-AI-Agent/src/components/ApiSettings.jsx（e-Stat 固有項目を除去）
function ApiSettings({
  apiKey,
  model,
  maxTokens,
  geminiApiKey,
  voiceModel,
  isOpen,
  onToggle,
  onApiKeyChange,
  onModelChange,
  onMaxTokensChange,
  onGeminiApiKeyChange,
  onVoiceModelChange,
  onSave,
  onDeleteKey,
}) {
  const handleSubmit = (event) => {
    event.preventDefault()
    onSave()
  }

  return (
    <div className="settings">
      <button
        className="secondary-button"
        type="button"
        onClick={onToggle}
        title="API設定"
      >
        ⚙<span className="btn-label"> API設定</span>
      </button>

      {isOpen && (
        <form className="settings-popover" aria-label="API設定" onSubmit={handleSubmit}>
          <label htmlFor="claude-api-key">Claude APIキー</label>
          <input
            id="claude-api-key"
            type="password"
            value={apiKey}
            placeholder="sk-ant-..."
            autoComplete="off"
            onChange={(event) => onApiKeyChange(event.target.value)}
          />
          <p className="field-help">
            APIキーは
            <a href="https://platform.claude.com/" target="_blank" rel="noopener noreferrer">
              platform.claude.com
            </a>
            で取得できます。
          </p>

          <label htmlFor="claude-model">Claudeモデル</label>
          <input
            id="claude-model"
            type="text"
            value={model}
            onChange={(event) => onModelChange(event.target.value)}
          />

          <label htmlFor="claude-max-tokens">最大出力トークン (max_tokens)</label>
          <input
            id="claude-max-tokens"
            type="number"
            min="1"
            value={maxTokens}
            onChange={(event) => onMaxTokensChange(Number(event.target.value) || 0)}
          />

          <hr className="settings-divider" />

          <label htmlFor="gemini-api-key">Gemini APIキー（音声機能）</label>
          <input
            id="gemini-api-key"
            type="password"
            value={geminiApiKey}
            placeholder="AIza..."
            autoComplete="off"
            onChange={(event) => onGeminiApiKeyChange(event.target.value)}
          />
          <p className="field-help">
            音声で相談する機能（Gemini Live API）に使います。キーは
            <a href="https://aistudio.google.com/apikey" target="_blank" rel="noopener noreferrer">
              Google AI Studio
            </a>
            で取得できます。ブラウザから直接接続するためキーは端末に保存されます。専用のキーを作り、
            利用上限を設定しておくことをおすすめします。
          </p>

          <label htmlFor="gemini-model">Geminiモデル（音声）</label>
          <input
            id="gemini-model"
            type="text"
            value={voiceModel}
            onChange={(event) => onVoiceModelChange(event.target.value)}
          />

          <div className="settings-actions">
            <button type="submit" className="save-button">
              保存して閉じる
            </button>
            <button
              type="button"
              className="ghost-button"
              onClick={onDeleteKey}
              disabled={!apiKey && !geminiApiKey}
            >
              キーを削除
            </button>
          </div>

          <p className="field-help">
            APIキーはこのブラウザの localStorage に保存され、リロード後も復元されます。
            共有端末では使用後に必ず削除してください。
          </p>
        </form>
      )}
    </div>
  )
}

export default ApiSettings
